import React from 'react';

import { IconUserX } from '@tabler/icons-react';

import {
  BanIcon,
  CheckMarkIcon,
  DeactivateIcon,
  LoginIcon,
  RequestVerificationIcon,
  SpinnerIcon,
  WarningIcon,
  YoungOnesBlackIcon,
} from './index';

interface IconType {
  icon: string;
  iconClass?: string;
}

export const Icon = ({ icon, iconClass }: IconType) => {
  const classes = `flex justify-center items-center ${iconClass}`;

  switch (icon) {
    case 'warning':
      return (
        <div className={classes}>
          <WarningIcon />
        </div>
      );

    case 'checkMark':
      return (
        <div className={classes}>
          <CheckMarkIcon />
        </div>
      );

    case 'spinner':
      return (
        <div className={classes}>
          <SpinnerIcon />
        </div>
      );

    case 'youngOnesBlack':
      return (
        <div className={classes}>
          <YoungOnesBlackIcon />
        </div>
      );

    case 'deactivate':
      return (
        <div className={classes}>
          <DeactivateIcon />
        </div>
      );
    case 'deAnonymize':
      return (
        <div className={classes}>
          <IconUserX />
        </div>
      );

    case 'ban':
      return (
        <div className={classes}>
          <BanIcon />
        </div>
      );

    case 'requestVerification':
      return (
        <div className={classes}>
          <RequestVerificationIcon />
        </div>
      );

    case 'login':
      return (
        <div className={classes}>
          <LoginIcon />
        </div>
      );

    default:
      return <></>;
  }
};

export default Icon;
